import { useState } from "react";
import { Form, Input } from "antd";
import { useApiCall } from "../services/api";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setData } from "../redux/auth/loginDataSlice";
import PrimaryButton from "../components/Forms/PrimaryButton";
import Verification from "../components/models/Verification";
import AppLogo from "../components/AppLogo";
import { formRules, roleIds, routePrefix } from "../constant";
import Paragraph from "antd/es/typography/Paragraph";

const Login = ({ pageType = "sales" }) => {
  const { postApi, loading } = useApiCall();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [form] = Form.useForm();

  const handlePassword = () => {
    navigate(`${routePrefix[pageType]}/forgot-password`);
  };

  const handleSubmit = async (values) => {
    const body = {
      ...values,
      type: values.username?.includes("@") ? "email" : "phone",
    };

    const res = await postApi(
      pageType === "customer" ? "customer/login" : "user/singin",
      body,
      true,
    );
    if (res?.status) {
      dispatch(setData(values));
      navigate(`${routePrefix[pageType]}/otp-verify`);
    }
  };

  return (
    <>
      <div className="container-full">
        <div className="min-h-screen bg-[#A33434] bg-style">
          <div className="min-h-screen py-10 flex justify-center items-center">
            <div className="border w-[90%] md:w-[60%] lg:w-[40%] p-[36px] rounded-[32px] bg-[#FFFFFFCC] backdrop-blur-154">
              <AppLogo />
              <div className="w-full">
                <p className="text-[64px] mt-4 font-normal text-[#353535] font-abhaya">
                  Welcome!
                </p>
                <div className="w-full mt-0 mb-[24px]">
                  <p className="font-normal text-base">
                    You can log in to our platform using your email ID or phone
                    number and password.
                  </p>
                </div>

                {/* --- Ant Design Form --- */}
                <Form
                  form={form}
                  layout="vertical"
                  className="max-w-full mx-auto"
                  onFinish={handleSubmit}
                  autoComplete="off"
                >
                  <Form.Item
                    label={
                      <span className="text-xl font-manrope font-normal text-[#000000]">
                        Email / Phone Number
                      </span>
                    }
                    name="username"
                    rules={formRules.required}
                  >
                    <Input
                      placeholder=""
                      className="h-[47.6px] bg-[#FFFFFF] border border-[#D9D9D9] text-[#000000] text-base rounded-2xl p-3.5 focus:outline-none focus:border-transparent"
                    />
                  </Form.Item>

                  <Form.Item
                    label={
                      <span className="text-xl font-manrope font-normal text-[#000000]">
                        Password
                      </span>
                    }
                    name="password"
                    rules={formRules.required}
                  >
                    <Input.Password
                      placeholder=""
                      className="h-[47.6px] bg-[#FFFFFF] border border-[#D9D9D9] text-[#000000] text-base rounded-2xl p-3.5 focus:outline-none focus:border-transparent"
                    />
                  </Form.Item>

                  {/* {pageType !== "admin" && ( */}
                  <div className="w-full my-0 flex justify-end">
                    <button
                      type="button"
                      onClick={handlePassword}
                      className="underline text-base font-bold font-manrope"
                    >
                      Forgot Password?
                    </button>
                  </div>
                  {/* )} */}
                  {pageType === "customer" && (
                    <div className="text-center mt-6">
                      <div className="font-normal text-base">
                        By using our platform you agree to our{" "}
                      </div>
                      <div className="">
                        <span
                          className="cursor-pointer underline text-base font-bold font-manrope"
                          onClick={() =>
                            window.open("/terms-and-conditions", "_blank")
                          }
                        >
                          Terms & Conditions
                        </span>
                        &nbsp; & &nbsp;
                        <span
                          className="cursor-pointer underline text-base font-bold font-manrope"
                          onClick={() =>
                            window.open("/privacy-policy", "_blank")
                          }
                        >
                          Privacy Policy
                        </span>
                      </div>
                    </div>
                  )}

                  <div className="w-full flex flex-col gap-3 justify-center">
                    <div
                      className={`w-full flex justify-center ${pageType === "customer" ? "mt-7" : "mt-6"}`}
                    >
                      <PrimaryButton
                        text="Proceed"
                        type="submit"
                        htmlType="submit"
                        loading={loading}
                        className="me-[30px]"
                      />
                    </div>
                    {pageType === "customer" && (
                      <div className="mx-auto flex flex-col justify-center text-center">
                        <Paragraph className="!mb-0 w-fit">
                          Don’t have an account?
                        </Paragraph>
                        <p
                          className="text-center cursor-pointer underline text-base font-bold font-manrope !leading-[1]"
                          onClick={() => navigate("/signup")}
                        >
                          Sign Up
                        </p>
                      </div>
                    )}
                  </div>
                </Form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;
